import { AccordionSideMenu } from './AccordionSideMenu';

export type { TypeAccordionSideMenuProps } from './types';

export default AccordionSideMenu;
